import { createClient } from "@liveblocks/client";
import { createRoomContext } from "@liveblocks/react";

const client = createClient({
  publicApiKey: process.env.REACT_APP_LIVEBLOCKS_PUBLIC_KEY,
  resolveUsers: async ({ userIds }) => {
    return userIds.map((userId) => ({
      name: "Anonymous",
      avatar: `https://api.dicebear.com/7.x/avataaars/svg?seed=${userId}`,
    }));
  },
});

export const {
  RoomProvider,
  useThreads,
  useCreateThread,
  useCreateComment,
} = createRoomContext(client);